var $a3c27c2ba9e67612$exports = {};
$a3c27c2ba9e67612$exports = {
    "info": `Tiedot`,
    "negative": `Virhe`,
    "notice": `Varoitus`,
    "positive": `Onnistui`
};


export {$a3c27c2ba9e67612$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
